import React from "react";
import Moment from "react-moment";

import ImagePreview from "../ImagePreview";
import VideoPreview from "../VideoPreview";
import StickerPreview from "../StickerPreview";

import "./style.css";
import LoadingAnimation from "../LoadingAnimation";

const BotReply = ({
  replyType,
  data,
  replyTime,
  replyId,
  bookmarkAction,
  showFeedback,
  feedback,
  recordFeedback,
  documentPreviewSetting,
  setDocumentPreview,
}) => {
  const getBotReplyItem = () => {
    if (data.template === "text") {
      return (
        <div className="text-reply-container">
          <div
            className="text-reply"
            dangerouslySetInnerHTML={{ __html: data.html }}
          ></div>
        </div>
      );
    } else if (data.template === "image" && data.image) {
      return <ImagePreview src={data.image.url} altText={data.text} />;
    } else if (data.template === "image" && !data.image) {
      return <ImagePreview html={data.html} altText={data.text} />;
    } else if (data.template === "video") {
      return <VideoPreview link={data.video.url} html={data.html} />;
    } else if (data.template === "sticker") {
      return <StickerPreview src={data.image.url} altText={"sticker"} />;
    }
  };

  if (replyType === "loading") {
    return (
      <div className="loading-bubble">
        <LoadingAnimation />
      </div>
    );
  }

  return (
    <div className="bot-reply-wrapper">
      <div className="flex-container">
        <div className="bot-reply-container">
          {data.template === "text" &&
            documentPreviewSetting &&
            documentPreviewSetting.allowed_channels &&
            documentPreviewSetting.allowed_channels.includes("widget") && (
              <div
                className="bot-document-preview-button"
                onClick={() => setDocumentPreview(data.text, replyId)}
              >
                Read More
              </div>
            )}
          {getBotReplyItem()}
          <div className="more-menu-wrapper">
            <button
              className="more-menu-button"
              onClick={() => bookmarkAction("bot", data.text)}
              title="Menu"
            >
              <i className="icon-star-outline"></i>
            </button>
          </div>
        </div>
        {showFeedback && (
          <div className="bot-reply-feedback-container">
            <i
              className={`icon-thumbs-up bot-reply-feedback-icon${
                feedback === 1 ? " bot-reply-feedback-icon-selected" : ""
              }`}
              onClick={() => recordFeedback(1, replyId)}
            />
            <i
              className={`icon-thumbs-down bot-reply-feedback-icon${
                feedback === 0 ? " bot-reply-feedback-icon-selected" : ""
              }`}
              onClick={() => recordFeedback(0, replyId)}
            />
          </div>
        )}
      </div>
      <div className="bot-reply-time">
        <Moment format="DD/MM/YYYY HH:mm" utc local>
          {new Date()}
        </Moment>
      </div>
    </div>
  );
};

export default BotReply;
